import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [dialog, setDialog] = useState({ open: false, mode: "login", reason: "" });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data?.id ? data : false);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const openAuth = (mode = "login", reason = "") => setDialog({ open: true, mode, reason });
  const closeAuth = () => setDialog((d) => ({ ...d, open: false }));

  return (
    <AuthCtx.Provider value={{ user, setUser, refresh, logout, dialog, openAuth, closeAuth }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
